import React from 'react';
import PropTypes from 'prop-types';
import { connect } from 'react-redux';
import Providers from '../constants/SocialPayConstants';
import { FormFieldWrapper as FormFieldsWrapper, FormFieldWithLabel as FormField } from 'views/FormComponents';
const { TWITTER } = Providers;
import { getCookie } from 'config/utils';
import scrollController from '../decorators/ScrollController';
import {
  handleChangeSocialPayInput,
  handleSubmitSocialPayForm,
} from '../actions/FinalizeSocialPayActions';

class FinalizeSocialPay extends React.Component {
  componentDidUpdate () {
    const { isFormValidated, isFormSubmitted } = this.props.finalizeSocialPay;
    if (isFormValidated && isFormSubmitted) {
      this.finalSubmitForm.submit();
    }
  }

  render () {
    const { twitter, twitter: { message, screenName, url, errors } } = this.props.finalizeSocialPay;
    return (
      <div>
        { twitter ?
          <form action={url} method="POST" ref={(ref) => this.finalSubmitForm = ref} onSubmit={(e) => {e.preventDefault(); this.props.handleSubmitSocialPayForm();}}>
            <input type="hidden" name="csrfmiddlewaretoken" value={getCookie('csrftoken')} />
            <FormFieldsWrapper>
              <FormField label="Edit Your Tweet" errors={errors.message}>
                <textarea
                    rows="5"
                    name="message"
                    value={message}
                    onChange={(e) => this.props.handleChangeSocialPayInput(TWITTER, { message: e.target.value })}
                  />
                <p>Tweeting from <a href={`//twitter.com/@${screenName}`}>@{screenName}</a></p>
              </FormField>
              <FormField>
                <input type="submit" className="btn" value="Pay with Tweet"/>
              </FormField>
            </FormFieldsWrapper>
          </form>
          : null
        }
      </div>
    );
  }
}

FinalizeSocialPay.propTypes = {
  isOpenable: PropTypes.bool.isRequired,
  isOpen: PropTypes.bool.isRequired,
  heading: PropTypes.oneOfType([PropTypes.string, PropTypes.node]).isRequired,
};

FinalizeSocialPay.defaultProps = {
  isOpenable: true,
  isOpen: false,
  isAnimated: true,
  heading: 'Social Pay',
};

function mapStateToProps (state) {
  const { finalizeSocialPay, settings: { isMobileDevice } } = state;
  return {
    finalizeSocialPay,
    isMobileDevice,
  };
}


export default connect(mapStateToProps, {
  handleChangeSocialPayInput,
  handleSubmitSocialPayForm,
})(scrollController(FinalizeSocialPay));



// WEBPACK FOOTER //
// ./src/payments/views/FinalizeSocialPay.js